module.exports = __webpack_public_path__ + "img/deviantart-white.c8fcd8a1.svg";